import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '../../../../assets/dist/tailwind.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import GuarPlugin from "./guard";
import './axios';
import i18n, { getLocale } from '../locale';
import locales from '../locale/vuetify';
import themes from './vuetifyThemes';
import VueApexCharts from 'vue-apexcharts';
import CKEditor from '@ckeditor/ckeditor5-vue2';

import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

import UtilPlugin from './util';
import MyDialog from '../views/components/common/MyDialog.vue';
import MyDatePicker from '../views/components/common/MyDatePicker.vue';
import MyDateTimePicker from '../views/components/common/MyDateTimePicker.vue';
import MyNumberField from '../views/components/common/MyNumberField.vue';
import MyTextField from '../views/components/common/MyTextField.vue';
import MySelect from '../views/components/common/MySelect.vue';

import VuetifyMask from "vuetify-mask";
import VueTheMask from 'vue-the-mask';
Vue.use(VuetifyMask);
Vue.use(VueTheMask);

Vue.use(UtilPlugin);
Vue.use(GuarPlugin);

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

Vue.use(VueLodash, { lodash: lodash });

Vue.use(Vuetify);

Vue.use(VueLoading, { color: "#42D69E"});
Vue.component("loading", VueLoading);
Vue.component("MyDialog", MyDialog);
Vue.component("MyDatePicker", MyDatePicker);
Vue.component("MyDateTimePicker", MyDateTimePicker);
Vue.component("MyNumberField", MyNumberField);
Vue.component("MyTextField", MyTextField);
Vue.component("MySelect", MySelect);

Vue.use(CKEditor);

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: themes[0],
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales,
    current: getLocale(),
    t: (key, ...params) => i18n.t(key, params) as string,
  },
});

/**
 * Set theme with number for Vuetify class object
 *
 * @param {Number} index new value
 */
export async function setVuetifyTheme(index) {
  if (vuetify.framework.theme.themes !== themes[index]) {
    console.log(`[Vuetify] Change theme to "${index}"`);
    vuetify.framework.theme.themes.light = themes[index].light || themes[0].light;
    vuetify.framework.theme.themes.dark = themes[index].dark || themes[0].dark;
  } else {
    console.warn(`[Vuetify] "${index}" is current theme `);
  }
}

/**
 * Set the mode to dark/light for the Vuetify class object.
 *
 * @param {Boolean} dark new value
 */
export async function setVuetifyThemeDark(dark) {
  console.log(`[Vuetify] Change theme to "${dark ? 'dark' : 'light'}"`);
  vuetify.framework.theme.dark = dark;
}

export default vuetify;
